import React, { useState } from "react";
import { Typography, Grid, Card, CardContent } from "@deere/fuel-react";
import SelfServiceButtons from "../SelfServiceButtons";
import { DEFAULT_GRID_COLLUMNS, QUESTION_TYPES, DEFAULT_LANGUAGE_CODE,  TRANSLATIONS, SURVEYPART_SECTION_TYPES, SUPPLIER_COLUMN, PART_COLUMN, PART_DESCRIPTION_COLUMN, DEFAULT_PART_COLUMNS } from "../../../../utils/surveyLiterals";
import { InputOpen, InputDatePicker, InputFile, InputCheck, InputSelect, InputRadio, InputViewer, InputCountry, InputState, InputMultiLine, InputOpen_Part, InputSelect_Part, InputSelect_Multi_Country, InputCheck_Part, InputTitlePopup_Part, InputCheckPopup_Part, InputFile_Part,InputMultiSelect_Part } from "../SelfServiceInputs";
import { getSelfServiceTranslation, getTextTranslation, getHelpTextTranslation } from "../../../../utils/utils";
import { DataGrid } from "@mui/x-data-grid";
import { POPUP_QUESTIONS_TITLES } from "../../../../utils/constants";
import ModalAddCountry from "../../../../components/coo/ModalAddCountry";

const ReviewStep = ({ currentStep, activeStep, setActiveStep, payloadData, isViewOnly }) => {

  const [showCountryModal, setShowCountryModal] = useState(false);
  const [rowToUpdateCountry, setRowToUpdateCountry] = useState({ id: null, country: null });
  const [currentLang, setCurrentLang] = useState(DEFAULT_LANGUAGE_CODE)
  const getCollumnsByQuestion = (questions, questionsGroup) => {
    const questionsInGroup = questions.filter((q) => q.questionsGroup === questionsGroup);
    return questionsInGroup ? DEFAULT_GRID_COLLUMNS / questionsInGroup.length : DEFAULT_GRID_COLLUMNS;
  };
  const isSelfService = currentLang!==null;
  const renderInputs = (q, currentLang) => {
    if (q && q.type)
      switch (q.type) {
        case QUESTION_TYPES.OPEN_SMALL:
          return <InputOpen que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.SELECT:
          return <InputSelect que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.CHECK:
          return <InputCheck que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.DATEPICKER:
          return <InputDatePicker que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.RADIO:
          return <InputRadio que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.FILE:
          return <InputFile que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.VIEWER:
          return <InputViewer que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.SEL_CNTRY:
        case QUESTION_TYPES.SEL_CTY_UW:
          return <InputCountry que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.SEL_STATE:
          return <InputState que={q} currentLang={currentLang}/>;
        case QUESTION_TYPES.OPEN:
          return <InputMultiLine que={q} currentLang={currentLang}/>;
      }
  };

  const fnValidate = () => {
    //This is a Review Step, hence validation is not required
    //Directly moving to next step
    setActiveStep((prevState) => {
      return prevState + 1;
    });
  };

  const isPopupQuestion = (que, section) => {
    let isPopupQue = false;
    if (que.codeQuestionDepends && que.codeQuestionDepends !== "") {
      let parent = section.questions.find((q) => q.code === que.codeQuestionDepends);
      if (POPUP_QUESTIONS_TITLES.includes(parent?.type)) {
        isPopupQue = true;
      } else if (parent?.codeQuestionDepends && parent?.codeQuestionDepends !== "") {
        isPopupQue = isPopupQuestion(parent, section);
      }
    }
    return isPopupQue;
  };
  const sampleCountries = [
    { code: "US", name: "United States" },
    { code: "CA", name: "Canada" },
    { code: "MX", name: "Mexico" },
    { code: "GB", name: "United Kingdom" },
    { code: "FR", name: "France" }
  ]

  const renderPartTable = (section) => {
    const columns = payloadData?.defaultColumns
        ?.filter((col) => !col.isNonDeere)
        ?.map((col) => {
          return { field: col.columnNames, headerName: getTextTranslation(col, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getTextTranslation(col, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), minWidth: 100, flex: 1 };
        }) ?? [];
    section.questions.sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1)).forEach((que) => {
      if (!isPopupQuestion(que, section)) {
        switch (que.type) {
          case QUESTION_TYPES.NUM:
          case QUESTION_TYPES.OPEN:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang), minWidth: 100, flex: 1, renderCell: () => <InputOpen_Part que={que} currentLang={currentLang} /> });
            break;
          case QUESTION_TYPES.SELECT:
          case QUESTION_TYPES.SEL_CNTRY:
          case QUESTION_TYPES.SEL_CTY_UW:
          case QUESTION_TYPES.SEL_STATE:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang ), minWidth: 100, flex: 1, renderCell: () => <InputSelect_Part que={que} currentLang={currentLang} /> });
            break;
          case QUESTION_TYPES.CHECK:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang), minWidth: 100, flex: 1, renderCell: () => <InputCheck_Part que={que} currentLang={currentLang} /> });
            break;
          case QUESTION_TYPES.TITL_POPUP:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang), minWidth: 100, flex: 1, renderCell: () => <InputTitlePopup_Part que={que} currentLang={currentLang} questions={section.questions}/> });
            break;
          case QUESTION_TYPES.CHEK_POPUP:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang), minWidth: 100, flex: 1, renderCell: () => <InputCheckPopup_Part que={que} currentLang={currentLang} questions={section.questions}/> });
            break;
          case QUESTION_TYPES.FILE:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang), minWidth: 100, flex: 1, renderCell: () => <InputFile_Part que={que} currentLang={currentLang} questions={section.questions}/> });
            break;
          case QUESTION_TYPES.MULT_CNTRY:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang), minWidth: 100, flex: 1, renderCell: (params) => <InputSelect_Multi_Country que={que} currentLang={currentLang} questions={section.questions} setShowCountryModal={() => { setRowToUpdateCountry(params.row); setShowCountryModal(true); }}/> });
            break;
          case QUESTION_TYPES.MULTI_SEL:
            columns.push({ field: que.code, headerName: getTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang, false), description: getHelpTextTranslation(que, TRANSLATIONS.toLocaleLowerCase(), currentLang ), minWidth: 100, flex: 1, renderCell: () => <InputMultiSelect_Part que={que} currentLang={currentLang} /> });  
            break;
        }
      }
    });
    const createModifiedColumns = (cols) => {
      return cols.map(col => ({
          ...col,
          headerName: col.headerName.length >= 50 ? col.headerName.slice(0, 50) + '...' : col.headerName
        }));
    };
    
    const modifiedColumns = createModifiedColumns(columns);
    
    const sampleData = {
      id: 1,
      [SUPPLIER_COLUMN]: "0000055571",
      [PART_COLUMN]: "0000ABC",
      [PART_DESCRIPTION_COLUMN]: "This is a representational Part.",
    };
    payloadData?.defaultColumns
      .filter((col) => !col.isNonDeere && !DEFAULT_PART_COLUMNS.includes(col.columnNames))
      .forEach((col) => (sampleData[col.columnNames] = `Sample ${col.columnNames} 1`));
    section.questions.forEach((que) => (sampleData[que.code] = ""));
    return (
      <Grid container mt={4} spacing={2} pl={3} pr={3}>
        <DataGrid
          columns={modifiedColumns}
          rows={[sampleData]}
          autoHeight
          headerHeight={110}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": { whiteSpace: "normal!important", lineHeight: 1.4, fontSize: "12px" },
            "& .MuiDataGrid-cell:focus-within": { outline: "none !important" },
            "& .MuiDataGrid-cellContent": { fontSize: "10px" },
            "& .MuiDataGrid-cell": { padding: "0 5px" },
          }}
        />
      </Grid>
    );
  };

  const countryChangePopupHandler = () => {
    return;
  };

  return (
    <>
    <Card>
      <CardContent>
        {!isViewOnly && (
          <>
            <Typography variant="h1">
              {currentStep.step} - {currentStep.title}
            </Typography>
            <hr />
          </>
        )}
        <Typography variant="h1" size="lg">
          {getSelfServiceTranslation(payloadData,  TRANSLATIONS.toLocaleLowerCase(), currentLang, false)}
        </Typography>
        {payloadData &&
          payloadData.sections &&
          payloadData.sections.filter((section) => section.type !== SURVEYPART_SECTION_TYPES.RESPONSES && section.type !== SURVEYPART_SECTION_TYPES.SUPPLIER).sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1)).map((section) => (
            <Card key={section.code} sx={{ margin: "15px 20px 15px 20px" }}>
              <CardContent>
                <Typography gutterBottom variant="h4">
                  { getSelfServiceTranslation(section,  TRANSLATIONS.toLocaleLowerCase(), currentLang, false)}
                </Typography>
                <Typography gutterBottom variant="subtitle1">
                  { getSelfServiceTranslation(section,  TRANSLATIONS.toLocaleLowerCase(), currentLang, true)}
                </Typography>
                {section.type === SURVEYPART_SECTION_TYPES.PART ? (
                    renderPartTable(section)
                  ) : (
                    <Grid container mt={4} spacing={2}>
                      {section &&
                        section.questions &&
                        section.questions
                          .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                          .map((q) => {
                            const collumnsByQuestion = q.questionsGroup ? getCollumnsByQuestion(section.questions, q.questionsGroup) : DEFAULT_GRID_COLLUMNS;
                            return (
                              <Grid item md={collumnsByQuestion} key={q.code}>
                                {renderInputs(q, currentLang)}
                              </Grid>
                            );
                          })}
                    </Grid>
                  )}
              </CardContent>
            </Card>
          ))
        }
        <Grid container justifyContent="flex-end">
          <SelfServiceButtons activeStep={activeStep} setActiveStep={setActiveStep} fnValidate={fnValidate} payloadData={payloadData} setCurrentLang={setCurrentLang} currentLang={currentLang} isViewOnly={isViewOnly}/>
        </Grid>
      </CardContent>
    </Card>
    {showCountryModal && (
      <ModalAddCountry showModal={showCountryModal} setShowModal={setShowCountryModal}  rowToUpdateCountry={rowToUpdateCountry} countryList={sampleCountries} saveHandler={countryChangePopupHandler} isSelfService={isSelfService}/>
    )}
    </>
  );
};

export default ReviewStep;
